import type { Message } from "@creators/backend/db/schema";
import type { OfferView } from "@creators/backend/lib/collabs/queries";
import type { Party } from "@creators/backend/lib/collabs/state-machine";

/**
 * Map system messages to the party that actually acted, using offer rows /
 * acceptedBy — not the "The creator/collaborator" wording, which can be wrong.
 */
export function partyActorsForMessages(
  messages: Message[],
  offerHistory: OfferView[],
  acceptedBy: Party | null | undefined,
): Map<string, Party> {
  const map = new Map<string, Party>();
  const counters = [...offerHistory]
    .filter((offer) => offer.version > 1)
    .sort(
      (a, b) =>
        a.version - b.version ||
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    );

  let counterIdx = 0;
  for (const message of messages) {
    const body = message.body ?? "";
    const isCounter =
      message.eventType === "offer.countered" ||
      (message.sender === "platform" && /\bcountered\b/i.test(body));
    if (isCounter) {
      const offer = counters[counterIdx++];
      if (offer?.createdBy === "creator" || offer?.createdBy === "brand") {
        map.set(message.id, offer.createdBy);
      }
      continue;
    }

    const isAccept =
      message.eventType === "offer.accepted" ||
      (message.sender === "platform" &&
        /\baccepted the terms\b|\baccepted\b/i.test(body) &&
        /frozen|Work can begin/i.test(body));
    if (isAccept && (acceptedBy === "creator" || acceptedBy === "brand")) {
      map.set(message.id, acceptedBy);
    }
  }

  return map;
}
